<template>
	<div style="background-color: #fff;margin: 10px;border-radius: 3px;">
		<div style="position: sticky;top:0;z-index: 999;background-color: #fff;padding-bottom: 1px;border-bottom: 1px solid #ebeef5;padding-top: 10px;">


			<!--带折叠的搜索start-->
			<div v-if="false">
				<el-form size="mini" style="display: flex;flex-wrap: wrap;padding-left: 20px;" :style="{'height':isShowCollapse?'auto':'50px'}" ref="searchForm" :model="searchForm" inline label-width="120px">

					<!--收起时显示的搜索项start 4个搜索项为一行-->
					<div v-show="!isShowCollapse" style="width: 80%;display: flex;">

						<el-form-item label="门店" style="width: 23%;display: flex;">
							
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>

						<el-form-item label="手机号" style="width: 23%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="手机号" clearable size="mini" />
						</el-form-item>


					</div>
					<!--收起时显示的搜索项end-->

					<!--展开时显示的搜索项start 4个搜索项为一行-->
					<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">
						<el-form-item label="门店" style="width: 35%;display: flex;">
							<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
								<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
							</el-select>
						</el-form-item>

						<el-form-item label="手机号" style="width: 35%;display: flex;">
							<el-input v-model="searchForm.mobile" placeholder="手机号" clearable size="mini" />
						</el-form-item>


					</div>
					<!--展开时显示的搜索项end-->

					<div :style="{'width':isShowCollapse?'100%':'13%','justify-content': isShowCollapse?'flex-end':'center' }" style="height: 30px; display: flex;margin: 0;margin-bottom: 10px;">
						<div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: #9A7E9C;font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
							<span v-if="!isShowCollapse">展开</span>
							<span v-else>收起</span>
							<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
						</div>
						<el-button round style="margin-right: 10px;" @click="handleSearch" type="primary" icon="el-icon-search" size="small">搜索</el-button>
						<el-button round @click="handleReset" size="small">重置</el-button>
						<div v-if="isShowCollapse" style="width: 70px;"></div>
					</div>


				</el-form>
			</div>
			<!--带折叠的搜索end-->

			<!-- 只允许单选的排序start -->
			<div style="margin-top: 10px;display: flex;align-items: center;background-color: #fff;margin-bottom: 15px; justify-content: space-between;">

				<div style="margin-right: 20px;margin-left: 35px;">
					<el-button @click="showAddOrEditTypePop" type="primary" round icon="el-icon-plus" size="mini">添加分类</el-button>
				</div>

				<div v-if="false" class="sortLine" style="font-size: 14px;display: inline-flex; margin-left: 40px; color: #6f6c5f;background-color: #e0f7ed;border-radius: 8px;overflow: hidden;margin-right: 68px;">

					<div class="sortItem dis" @click="sort(-1)" :style="{color: sortIndex==-1?'#fff':'#777','font-weight': sortIndex==-1?'bold':'400','background-color': sortIndex==-1?'#9E819F':''}">
						默认</div>
					<!-- 排序项start -->
					<div class="sortItem dis" @click="sort(0,'updated_at')" :style="{color: sortIndex==0?'#fff':'#777','font-weight': sortIndex==0?'bold':'400','background-color': sortIndex==0?'#9E819F':''}">
						时间
						<img v-if="sortIndex==0&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==0&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>
					<!-- 排序项end -->
					<div class="sortItem dis" @click="sort(1,'sales')" :style="{color: sortIndex==1?'#fff':'#777','font-weight': sortIndex==1?'bold':'400','background-color': sortIndex==1?'#9E819F':''}">
						销量
						<img v-if="sortIndex==1&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==1&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

					<div class="sortItem dis" @click="sort(2,'price')" :style="{color: sortIndex==2?'#fff':'#777','font-weight': sortIndex==2?'bold':'400','background-color': sortIndex==2?'#9E819F':''}">
						售价
						<img v-if="sortIndex==2&&sortContent=='asc'" :src="shang" style="width: 15px;height: 15px;margin-left: 3px;" />
						<img v-if="sortIndex==2&&sortContent=='desc'" :src="xia" style="width: 15px;height: 15px;margin-left: 3px;" />
					</div>

				</div>


			</div>
			<!-- 只允许单选的排序end -->
		</div>





		<!--表格start :height="tableHeight+'px'"-->

		<el-table id="mTable" :cell-style="{ 'text-align': 'center'}" :row-style="{ 'text-align': 'center'}" :height="tableHeight" :data="typeArr" style="width: 100%">
			<el-table-column type="expand">

				<template slot-scope="props">
					<div style="padding: 20px;padding-left: 50px;background-color: #F5F7FA;margin-top: -10px;display: flex;width: 100%;">

						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">id</span></div>
						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">名称</span></div>
						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">图片</span></div>
						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">排序</span></div>
						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">创建时间</span></div>
						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">更新时间</span></div>
						<div class="dis" style="flex: 1;text-align: center;"><span style="color:rgb(136, 136, 136);font-size: 12px;">操作</span></div>
					</div>
					<div v-if="props.row.children.length==0" style="background-color: #F5F7FA;text-align: center;padding: 30px;margin-top: -10px;color:rgb(136, 136, 136);font-size: 12px;">暂无数据</div>
					<div v-for="childerItem in props.row.children" :key='childerItem.id'>

						<div style="padding: 20px;padding-left: 50px;background-color: #F5F7FA;margin-top: -10px;display: flex;width: 100%;border-top: 1px solid #eee;">

							<div class="dis" style="flex: 1;text-align: center;"> <span style="font-size: 13px;color: #333;"> {{childerItem.id}}</span></div>
							<div class="dis" style="flex: 1;text-align: center;"> <span style="font-size: 13px;color: #333;">{{childerItem.name}}</span></div>
							<div class="dis" style="flex: 1;text-align: center;"><img :src="childerItem.image" style="width: 50px;height: 50px;cursor: pointer;" @click="handlePreView(childerItem.image)" /> </div>
							<div class="dis" style="flex: 1;text-align: center;"> <span style="font-size: 13px;color: #333;">{{childerItem.sort}}</span></div>
							<div class="dis" style="flex: 1;text-align: center;"> <span style="font-size: 13px;color: #333;">{{childerItem.created_at}}</span></div>
							<div class="dis" style="flex: 1;text-align: center;"> <span style="font-size: 13px;color: #333;">{{childerItem.updated_at}}</span></div>

							<div class="dis" style="flex: 1;text-align: center;">
								<el-dropdown trigger="hover" style="width: 80px;">
									<el-button size="mini" round type="primary">
										操作<i class="el-icon-arrow-down el-icon--right"></i>
									</el-button>
									<el-dropdown-menu slot="dropdown">


										<el-dropdown-item>
											<el-button type="success" size="mini" round @click="showType2EditGoods(childerItem)">编辑
											</el-button>
										</el-dropdown-item>

										<el-dropdown-item>
											<el-button type="danger" size="mini" round @click="showType2Del(props.row,childerItem)">删除
											</el-button>
										</el-dropdown-item>


									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>

					</div>
				</template>

			</el-table-column>
			<el-table-column label="ID" prop="id"></el-table-column>
			<el-table-column label="名称" prop="name"></el-table-column>
			<el-table-column label="英文名称" prop="ename"></el-table-column>
			<el-table-column label="排序" prop="sort"></el-table-column>
			<el-table-column label="创建时间" prop="created_at"></el-table-column>
			<el-table-column label="更新时间" prop="updated_at"></el-table-column>


			<el-table-column label="操作">
				<template slot-scope="{ row, index }">
					<el-dropdown trigger="hover" style="width: 80px;">
						<el-button size="mini" round type="primary">
							操作<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>
						<el-dropdown-menu slot="dropdown">


							<el-dropdown-item>
								<el-button type="success" size="mini" round @click="showType1EditGoods(row)">编辑
								</el-button>
							</el-dropdown-item>


						</el-dropdown-menu>
					</el-dropdown>

				</template>
			</el-table-column>
		</el-table>
		<!--表格end-->

		<!--分页start-->
		<!-- <el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
			<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
			<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
		</el-row> -->
		<!--表格end-->

		<!--浏览图片的弹窗start-->
		<el-dialog :close-on-click-modal="false" width="400px" footer-hide title="预览" :visible.sync="isShowPreImg">
			<img :src="preImgUrl" style="width: 100%">
		</el-dialog>
		<!--浏览图片的弹窗end-->



		<!-- 添加或编辑一级分类弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" custom-class="m-dialog" title="一级分类" center :visible.sync="isShowAddType1Pop">
			<div v-if="isShowAddType1Pop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="type1Form" :rules="type1FormRules" :model="type1Form">


						<el-form-item label="名称" prop="name">
							<el-input style="width: 250px;" v-model="type1Form.name" placeholder="请输入名称"></el-input>
						</el-form-item>

						<el-form-item label="英文名称" prop="ename">
							<el-input style="width: 250px;" v-model="type1Form.ename" placeholder="请输入英文名称"></el-input>
						</el-form-item>

						<el-form-item label="排序" prop="sort">
							<el-input min="0" max="100" style="width: 250px;" type="number" v-model="type1Form.sort" placeholder="请输入0-100的排序值"></el-input>
						</el-form-item>

					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="type1Save('type1Form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加或编辑一级分类弹窗end -->



		<!-- 添加或编辑二级分类弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" custom-class="m-dialog" title="二级分类" center :visible.sync="isShowAddType2Pop">
			<div v-if="isShowAddType2Pop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="type2Form" :rules="type2FormRules" :model="type2Form">


						<el-form-item label="名称" prop="name">
							<el-input style="width: 250px;" v-model="type2Form.name" placeholder="请输入名称"></el-input>
						</el-form-item>

						<el-form-item label="图片" prop="image" style="position: relative;">
							<div style="position: absolute;top: 20px;left: -59px;font-size: 12px;color: #aaa;">120*120</div>
							<upload-img :imgWidth="120" :imgHeight="120" :limit='1' accept="image/png" fileAfterName=".png" ref="fengMianUpload" :imgList="type2Form.image"></upload-img>

						</el-form-item>

						<el-form-item label="排序" prop="sort">
							<el-input min="0" max="100" style="width: 250px;" type="number" v-model="type2Form.sort" placeholder="请输入0-100的排序值"></el-input>
						</el-form-item>


					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="type2Save('type2Form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加或编辑二级分类弹窗end -->



		<!-- 添加分类弹窗start -->
		<el-dialog :close-on-click-modal="false" width="600px" custom-class="m-dialog" title="分类信息" center :visible.sync="isShowAddOrEditTypePop">
			<div v-if="isShowAddOrEditTypePop">
				<div style="padding-top: 20px;">

					<el-form style="margin-left: 80px;" label-width="100px" size="small" ref="form" :rules="formRules" :model="form">

						<el-form-item label="一级分类" prop="classes_id">
							<el-select v-model="form.classes_id" clearable placeholder="请选择" @change="type1SelectChange">

								<el-option v-for="item in type1" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>

							<el-button type="primary" @click="showAddType1Pop" style="border-radius: 0;margin-left: -5px;position: relative;border-top-right-radius: 4px;border-bottom-right-radius: 4px;z-index: 2;">添加</el-button>

						</el-form-item>

						<el-form-item label="二级分类" prop="category_id">
							<!--  :disabled="form.classes_id?false:true" -->
							<el-select v-model="form.category_id" clearable placeholder="请选择">

								<el-option v-for="item in type2" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>

							<!-- :disabled="form.classes_id?false:true" -->
							<el-button type="primary" @click="showAddType2Pop" style="border-radius: 0;margin-left: -5px;position: relative;border-top-right-radius: 4px;border-bottom-right-radius: 4px;z-index: 2;">添加</el-button>

						</el-form-item>





					</el-form>

				</div>
				<div class="dis" style="justify-content: flex-end;">

					<el-button round style="margin-left: 10px" @click="save('form')" type="primary" size="small">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 添加分类弹窗end -->


		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->
	</div>
</template>

<script>
	import {
		ajax
	} from '../../util/ajax.js';
	import uploadImg from '../../components/upload/uploadImg.vue'

	export default {
		name: 'brand',
		components: {
			uploadImg
		},
		data() {
			return {
				rowGoods_id: '', //列表项的商品id

				isShowCollapse: false, //是否展开搜索项
				searchForm: {


				},

				isShowAddOrEditTypePop: false, //是否显示添加或编辑弹窗
				isShowPreImg: false, //是否显示浏览图片的弹窗
				preImgUrl: '', //浏览图片弹窗的图片地址
				isShowType1EditGoods: false, //是否显示修改一级分类弹窗
				type1EditRow: '', //修改的一级分类对象

				tableHeight: 0, //表格高度
				loading: false,
				tableData: [], //表格数据
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				shang: require("@/assets/shang.png"),
				xia: require("@/assets/xia.png"),
				sortIndex: -1, //排序项
				sortContent: '', //排序项的值 desc 或esc
				sortFlag: true, //排序箭头切换


				type1: [], //一级分类
				type2: [], //二级分类
				type2SeletcArr: [], //根据选择的一级分类查找到的二级分类列表
				isShowAddType1Pop: false, //是否显示添加一级分类弹窗
				isShowAddType2Pop: false, //是否显示添加一级分类弹窗
				type1Form: {
					classes_id: '',
					ename: '',
					name: '',
					sort: 0
				},
				type1FormRules: {

					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					ename: [{
						required: true,
						message: '请输入英文名称',
						trigger: 'blur'
					}],
					// image: [{
					// 	type: 'array',
					// 	required: true,
					// 	message: '请选择上传品牌图片',
					// 	trigger: 'change'
					// }],
					sort: [{
						required: true,
						message: '请输入排序',
						trigger: 'blur'
					}]
				},


				type2Form: {
					category_id: '', //二级id
					image: [],
					name: '',
					sort: 0
				},
				type2FormRules: {

					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],

					image: [{
						type: 'array',
						required: true,
						message: '请选择上传图片',
						trigger: 'change'
					}],
					sort: [{
						required: true,
						message: '请输入排序',
						trigger: 'blur'
					}]
				},
				storeList:[],//门店列表
				form: {
					classes_id: '', //一级分类
					category_id: '', //二级分类
					status: 1, //状态 (0: 删除, 1: 添加)
				},
				formRules: {
					classes_id: [{
						required: true,
						message: '请选择一级分类',
						trigger: 'change'
					}],
					category_id: [{
						required: true,
						message: '请选择二级分类',
						trigger: 'change'
					}],
				},



				typeArr: [], //分类列表



			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},
		created() {
			this.getTableHeight();
		},
		mounted() {

			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};

			this.getStore();
			this.initData();
		},

		methods: {
			//获取门店列表
			async getStore(){
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},
			//初始化表格数据
			async initData() {

				this.loading = true
				let res = await ajax('/hq/classes', 'GET'); //获取一级分类列表

				let arr = res.data.data.classes;
				console.log('一级分类=>', arr)
				this.type1 = arr;

				let typeArr = [];
				for (let i of arr) {
					let obj = i;
					i.children = []; //二级分类


					let resChild = await ajax('/hq/category', 'GET', {
						classes_id: i.id
					}); //获取二级分类列表
					let cateArr = resChild.data.data.category;



					for (let ii of cateArr) {
						obj.children.push(ii);
					}
					typeArr.push(obj);
				}


				let resChild = await ajax('/hq/category', 'GET'); //获取二级分类列表
				let cateArr = resChild.data.data.category;
				this.type2 = cateArr;

				this.loading = false;
				this.typeArr = typeArr;
				// if(this.form.classes_id){
				// 	this.type1SelectChange(this.form.classes_id);
				// }

				// this.loading = true
				// var searchForm = this.searchForm
				// let param = {

				// store_id:searchForm.store_id,//搜索的 门店id
				// mobile:searchForm.mobile,//搜索的 手机号

				// 	count: this.pageSize,
				// 	page: this.pageNumber
				// }

				// if(searchForm.sort){
				// 	param.sort =searchForm.sort;//排序的属性名
				// 	param.sort_rule = searchForm.sort_rule;//排序的方式
				// }

				// let ress = await ajax('/hq/brand', 'GET', param);
				// this.loading = false;
				// let res = ress.data.data;

				// this.total = res.total;
				// this.tableData = res.brand;
			},


			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 150; //距离页面下方的高度,值越大表格高度越小
				let tableHeightDetil = window.innerHeight - tableH;
				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},

			//删除分类
			async showType2Del(type1Item, type2Item) {

				this.$confirm('确定要删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.loading = true
					let ress = await ajax('/hq/classes/category', 'PUT', {
						classes_id: type1Item.id,
						category_id: type2Item.id,
						status: 0
					});
					this.loading = false;
					this.$message({
						message: '成功',
						type: 'success'
					});
					
					this.initData();
				});
				
			},

			//弹出修改一级分类弹窗
			showType1EditGoods(row) {
				this.isShowAddType1Pop = true;

				this.type1Form.classes_id = row.id;
				this.type1Form.ename = row.ename;
				this.type1Form.name = row.name;
				this.type1Form.sort = row.sort;

			},
			//弹出修改二级分类弹窗
			showType2EditGoods(row) {
				this.isShowAddType2Pop = true;
				console.log('row=>', row)
				this.type2Form.category_id = row.id;
				this.type2Form.image = [{
					url: row.image
				}];
				this.type2Form.name = row.name;
				this.type2Form.sort = row.sort;

			},
			//添加一级分类弹窗
			showAddType1Pop() {
				this.isShowAddType1Pop = true;
			},
			//添加二级分类弹窗
			showAddType2Pop() {
				this.isShowAddType2Pop = true;
			},
			//添加分类的弹窗上一级类别的改变事件
			type1SelectChange(id) {
				// let arr = [];
				// this.typeArr.forEach((item)=>{

				// 	if(item.id==id){
				// 		let arr = item.children;
				// 	}
				// })

				// this.type2SeletcArr = arr;
				// console.log('this.type2SeletcArr',this.type2SeletcArr)
			},
			//点击编辑
			showEditBrand(row) {
				this.form.brand_id = row.id;
				this.form.name = row.name;
				this.form.image = [{
					url: row.image
				}];
				this.form.sort = row.sort;
				this.isShowAddOrEditTypePop = true;
			},
			//添加品牌弹窗
			showAddOrEditTypePop() {
				this.isShowAddOrEditTypePop = true;
			},

			//一级分类的保存
			async type1Save(formName) {

				this.$refs[formName].validate(async (valid) => {
					if (valid) {

						let method = 'POST';
						if (this.type1Form.classes_id) {
							method = 'PUT';
						}

						if (this.type1Form.sort < 0 || this.type1Form.sort > 100) {
							this.$message.error('请填写0-100的排序值');
							return
						}
						this.loading = true;
						console.log('this.type1Form.classes_id', this.type1Form.classes_id)
						console.log('请求方式=>', method)
						let ress = await ajax('/hq/classes', method, {
							classes_id: this.type1Form.classes_id,
							name: this.type1Form.name,
							ename: this.type1Form.ename,
							sort: this.type1Form.sort
						});
						this.loading = false;

						this.$refs[formName].resetFields();
						this.type1Form = {
							classes_id: '',
							ename: '',
							name: '',
							sort: 0
						};

						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddType1Pop = false;
						this.initData();
					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});


			},



			//二级分类的保存
			async type2Save(formName) {
				this.type2Form.image = this.$refs.fengMianUpload.getImgList(); //图片
				this.$refs[formName].validate(async (valid) => {
					if (valid) {

						let method = 'POST';
						if (this.type2Form.category_id) {
							method = 'PUT';
						}
						if (this.type2Form.sort < 0 || this.type2Form.sort > 100) {
							this.$message.error('请填写0-100的排序值');
							return
						}
						this.loading = true;
						let ress = await ajax('/hq/category', method, {
							category_id: this.type2Form.category_id,
							name: this.type2Form.name,
							image: this.type2Form.image[0].url,
							sort: this.type2Form.sort
						});
						this.loading = false;

						this.$refs[formName].resetFields();
						this.type2Form = {
							category_id: '', //二级id
							image: [],
							name: '',
							sort: 0
						};

						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddType2Pop = false;
						this.initData();
					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});


			},



			//添加分类的保存
			async save(formName) {

				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.loading = true;
						let ress = await ajax('/hq/classes/category', 'PUT', {
							classes_id: this.form.classes_id,
							category_id: this.form.category_id,
							status: this.form.status

						});
						this.loading = false;

						this.$refs[formName].resetFields();
						this.form = {
							classes_id: '',
							category_id: '',
							status: 1

						};

						this.$message({
							message: '成功',
							type: 'success'
						});
						this.isShowAddOrEditTypePop = false;
						this.initData();
					} else {
						this.$message.error('请填写完整信息');
						return false;
					}
				});


			},
			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//翻页
			changePage(pageNumber) {
				console.log('即将翻到' + pageNumber + '页')
				this.pageNumber = pageNumber
				this.initData()
			},

			//点击头像
			handlePreView(url) {
				this.preImgUrl = url
				this.isShowPreImg = true
			},


			//排序 index是点击的项的索引,formName是属性名
			sort(index, formName) {
				//点击了默认排序
				if (index == -1) {
					this.sortIndex = -1;
					this.sortContent = ''; //排序的值 desc / esc
					this.sortFlag = true;
					//使用index把所有的搜索项值为''然后再发送请求获取到默认列表
					this.pageNumber = 1; //页码修改为1
					this.tableData = []; //表格数据修改为空
					this.searchForm.sort = ''; //排序的属性名
					this.searchForm.sort_rule = ''; //排序的方式
					//获取默认排序的表格数据

					this.initData(); //获取默认排序的表格数据
					return
				}
				//点击还是当前搜索项那么就进行升降序切换
				if (index == this.sortIndex) {
					this.sortFlag = !this.sortFlag;
					//把当前点击的搜索项切换为desc为降序
					if (this.sortFlag) {
						this.sortContent = 'desc'; //排序的值 desc / esc
						//使用index把所有的搜索项值为''然后把当前点击的搜索项的值修改为desc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'desc'; //排序的方式
						//获取表格列表

						this.initData(); //获取当前点击的搜索项的表格数据
					} else {
						//把当前点击的搜索项切换为esc为升序
						//使用index把所有的搜索项值为''然后把当前搜索项的值修改为asc
						this.sortContent = 'asc'; //排序的值 desc / asc
						this.pageNumber = 1; //页码修改为1
						this.tableData = []; //表格数据修改为空
						this.searchForm.sort = formName; //排序的属性名
						this.searchForm.sort_rule = 'asc'; //排序的方式
						//获取表格列表
						this.initData(); //获取当前点击的搜索项的表格数据
					}
					return
				}
				//当前点击的搜索项是其他的搜索项
				this.sortIndex = index; //当前点击的搜索项的索引号
				this.sortContent = 'desc'; //排序的值 desc / esc
				this.sortFlag = true;
				//使用index把所有的搜索项值为''然后把当前搜索项的值修改为desc然后再发送请求获取到列表
				this.pageNumber = 1; //页码修改为1
				this.tableData = []; //表格数据修改为空
				this.searchForm.sort = formName; //排序的属性名
				this.searchForm.sort_rule = 'desc'; //排序的方式
				//获取表格列表

				this.initData(); //获取当前点击的搜索项的排序的表格数据
			},




			//搜索
			handleSearch() {
				this.pageNumber = 1;
				this.initData()
			},

			//重置
			handleReset() {
				this.$refs.searchForm.resetFields();
				this.searchForm = {};
				this.sortIndex = -1;
				this.sortContent = ''; //排序的值 desc / esc
				this.sortFlag = true;
				this.pageNumber = 1
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},






		}


	}
</script>

<style scoped>
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;
		color: #2d8cf0;
		font-weight: 600;
	}

	.tableTem .avatar img {
		border-radius: 10px;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {

		padding-right: 20px;
		display: flex;
		justify-content: center;

	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.tableTem .dianL {
		text-align: left;
		font-size: 13px;
		color: #333;
	}


	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
	}

	.sortItem {

		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		min-width: 80px;
	}

	>>>#mTable th {
		text-align: center;
	}

	.sortItem:hover {
		background-color: #9E819F !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.el-table tbody tr:hover>td {
		background-color: #ffffff !important
	}


	>>>.el-icon-arrow-down {
		font-size: 12px;
	}

	>>>.demonstration {
		display: block;
		color: #8492a6;
		font-size: 14px;
		margin-bottom: 20px;
	}

	>>>.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}

	>>>.el-table td {
		padding: 10px 0 !important;
	}
</style>
